/* eslint-disable react-hooks/exhaustive-deps */
import clsx from 'clsx'

import {useEffect, useState} from 'react'
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';

const MySwal = withReactContent(Swal)
export const LinkedList = (props) => {
  let _datalist_a = props.datalist_a || []
  let _datalist_b = props.datalist_b || []
  const is_valid = props.is_valid || false;
  const is_invalid = props.is_invalid || false;
  let [datalist_a, setDatalist_a] = useState([])
  let [datalist_b, setDatalist_b] = useState([])
  let [isFirst, setIsFirst] = useState(true)
  useEffect(() => {
    if(!isFirst || (_datalist_a.length === 0 && _datalist_b.length === 0)) {
      return;
    }
    
    setDatalist_a(_datalist_a)
    setDatalist_b(_datalist_b)
  },[_datalist_a, _datalist_b]);

  let children = props.children
  let canMove = props.canMove || ((item) => true)
  const [selected_a, setSelected_a] = useState<Array<number>>([])
  const [selected_b, setSelected_b] = useState<Array<number>>([])
  const cannotMoveA = props.cannotMoveA || "Impossibile spostare l'elemento"
  const cannotMoveB = props.cannotMoveB || "Impossibile spostare l'elemento"
  const itemFilter = props.itemFilter || ((item:any, search:string) => { return true })
  const onChange = props.onChange || ((datalist) => {})
  const move = (list_from: string) => {

    if(list_from === 'a') {

      
      let selected = datalist_a.filter((item, index) => selected_a.includes(index)).filter((item) => canMove(item, 'a'))
      let cannot_move_selected = datalist_a.filter((item, index) => selected_a.includes(index)).filter((item) => !canMove(item, 'a'))
      if(cannot_move_selected.length > 0) {
        

        MySwal.fire({
          title: "Attenzione",
          text: cannotMoveA,
          icon: 'warning',
          showCancelButton: true,
          cancelButtonText: "Ok",
          showConfirmButton: false
        })

      }
      if(selected.length > 0) {
      
          let _datalist_b = [...datalist_b, ...selected]
          let _datalist_a = datalist_a.filter((item, index) => {
            
            for(let i = 0; i < selected.length; i++) {
              if(selected[i] === item) {
                return false
              }
            }
            return true
          })
          setIsFirst(false)
          onChange(_datalist_b);
          setDatalist_a(_datalist_a);
          setDatalist_b(_datalist_b);
          setSelected_a([]);
          
       
      }
    }else{
      let selected = datalist_b.filter((item, index) => selected_b.includes(index)).filter((item) => canMove(item, 'b'))
      let cannot_move_selected = datalist_a.filter((item, index) => selected_a.includes(index)).filter((item) => !canMove(item, 'ab'))
      console.log("selected",selected);
      if(cannot_move_selected.length > 0) {
        

        MySwal.fire({
          title: "Attenzione",
          text: cannotMoveB,
          icon: 'warning',
          showCancelButton: true,
          cancelButtonText: "Ok",
          showConfirmButton: false
        })

      }
      if(selected.length > 0) {
        let _datalist_a = [...datalist_a, ...selected]
        let _datalist_b = datalist_b.filter((item, index) => {
          for(let i = 0; i < selected.length; i++) {
            if(selected[i] === item) {
              return false;
            }
          }
          return true;
        });
        setIsFirst(false)
        setDatalist_a(_datalist_a);
        setDatalist_b(_datalist_b);
        setSelected_b([]);
        onChange(_datalist_b);
      }
    }
      
  }
  return (
    <div className='row mb-6'>
      <div className='col-md-5'>
        <ListElements
          list={datalist_a}
          is_valid={is_valid}
          is_invalid={is_invalid}
          drawItem={children}
          changeSelect={(selected: Array<number>) => {
            setSelected_a(selected)
          }}
          selected={selected_a}
          itemFilter={itemFilter}
        ></ListElements>
      </div>
      <div className='col-md-2'>
        <button
          type='button'
          onClick={() => {
            move('a')
          }}
          className='btn btn-outline-primary btn-outline w-100 mt-15 mb-2'
        >
          {'>'}
        </button>
        <button
          type='button'
          onClick={() => {
            move('b')
          }}
          className='btn btn-outline-primary btn-outline w-100'
        >
          {'<'}
        </button>
      </div>
      <div className='col-md-5'>
        <ListElements
         is_valid={is_valid}
         is_invalid={is_invalid}
          list={datalist_b}
          drawItem={children}
          list_type='b'
          selected={selected_b}
          changeSelect={(selected: Array<number>) => {
            setSelected_b(selected)
          }}
          itemFilter={itemFilter}
        ></ListElements>
      </div>
    </div>
  )
}

const ListElements = (props) => {
  const list:any = props.list || []
 

  const itemFilter = props.itemFilter || ((item:any, search:string) => { return true })
  const is_valid = props.is_valid || false;
  const is_invalid = props.is_invalid || false;
  const list_type = props.list_type || 'a'
  const [search, setSearch] = useState('')
  const drawItem = props.drawItem || ((item) => <>{item}</>)
  const changeSelect = props.changeSelect || ((selected: Array<number>) => {})
  const _defSelected:Array<number> = props.selected || []
  const [selected, setSelected] = useState<Array<number>>(_defSelected)
  useEffect(() => {
    setSelected(_defSelected)
  },[_defSelected]);
  return (
    <>
      <input type='text' className='form-control mb-1'  value={search} onChange={(e:any)=>{

        setSearch(e.target.value)
      }}  placeholder='Cerca...' />
      <div className={clsx('list-container',
        {
          is_invalid: is_invalid,
          is_valid:is_valid,
          'list-container-a': list_type === 'a',
          'list-container-b': list_type === 'b',
        }
      )}>
        {list.filter((item:any)=>( itemFilter(item, search))).map((item, index) => (
          
            <div 
              
              className={clsx(
                'list-item',

                {
                  selected: selected.includes(index),
                }
              )}
              key={index}
              onClick={() => {
                let _selected:Array<number> = [];
                if (selected.includes(index)) {
                  _selected = selected.filter((i) => i !== index)
             
                } else {
                  _selected = [...selected, index]
                  
                }

                setSelected(_selected)
                changeSelect(_selected)
                
                
              }}
            >
              {drawItem(item, index, list_type)}
            </div>
          
        ))}
      </div>
    </>
  )
}
